<template>
  <div class="articleIntro">
    <div class="article-coverImg">
      <ArticleImage
        :link="'/mag/article/'+ articleInfo.ID"
        :img-src="articleInfo.CoverImage"
      />
    </div>
    <div class="article-title">
      <h3><a :href="'/mag/article/'+ articleInfo.ID">{{ articleInfo.Title }}</a></h3>
    </div>
    <div class="article-date"><span>{{ formateDate }} </span></div>
    <div class="article-content">
      <p v-html="articleInfo.Summary" />
    </div>
    <div class="article-link">
      <a :href="'/mag/article/'+ articleInfo.ID" class="btn">Read More</a>
    </div>
  </div>
</template>

<script setup>
import { computed } from 'vue';
import ArticleImage from '@page/article/components/parts/ArticleImage';

const props = defineProps({
  articleInfo: {
    type: Object,
    required: true,
  },
});

function dateFormate(dataSrc) {
  const monthNames = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];

  const dateArray = dataSrc.split('/');
  const y = dateArray[0];
  const m = monthNames[dateArray[1] - 1];
  const d = dateArray[2];

  const date = `${m} ${d}, ${y}`;
  return date;
}

const formateDate = computed(() => {
  return dateFormate(props.articleInfo.PostTime);
});

</script>
